import React from 'react';
import { handleImageError } from '../lib/imageFallback';

/**
 * Responsive image with WebP + JPEG fallback and mobile/desktop srcsets.
 *
 * Given basePath = "/images/hero", it will produce:
 *   <picture>
 *     <source type="image/webp"
 *             srcset="/images/hero-sm.webp 800w, /images/hero-lg.webp 1600w" ... />
 *     <img src="/images/hero-lg.jpg"
 *          srcset="/images/hero-sm.jpg 800w, /images/hero-lg.jpg 1600w" ... />
 *   </picture>
 *
 * Browsers pick the smallest suitable variant. Old browsers get the JPG fallback.
 * All variants are self-hosted at /public/images/, so no external CDN can be blocked.
 */
const ResponsiveImage = ({
  basePath,           // e.g. "/images/hero" (no extension)
  alt,
  className = '',
  sizes = '(max-width: 768px) 100vw, 800px',
  fetchPriority,
  loading = 'lazy',
  decoding = 'async',
  onClick,
  style,
}) => {
  const webpSm = `${basePath}-sm.webp`;
  const webpLg = `${basePath}-lg.webp`;
  const jpgSm = `${basePath}-sm.jpg`;
  const jpgLg = `${basePath}-lg.jpg`;
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`${webpSm} 800w, ${webpLg} 1600w`}
        sizes={sizes}
      />
      <img
        src={jpgLg}
        srcSet={`${jpgSm} 800w, ${jpgLg} 1600w`}
        sizes={sizes}
        alt={alt}
        loading={loading}
        decoding={decoding}
        fetchPriority={fetchPriority}
        onError={handleImageError}
        onClick={onClick}
        className={className}
        style={style}
      />
    </picture>
  );
};

export default ResponsiveImage;
